import Vue from 'vue';

// helper function
// this removes the "s." part from the search key
function removeSdot (obj) {
    let targetObj = JSON.parse(JSON.stringify(obj))

    for (var key in targetObj) {
       if (targetObj.hasOwnProperty(key)) {
            if(key.startsWith("s.")){
                targetObj[key.substr(2)] = targetObj[key]
                delete targetObj[key]
            }

       }
    }
    
    return targetObj
}

const state = {
    isCreatingInvoice: false,
    isDownloadingInvoiceResume: false,
    isDownloadingInvoiceResumeBulk: false,
    isCancelingInvoice: false,
    isPrintingInvoice: false,
    valueToAskMoreBillingInfo: 1000,
    defaultInvoiceSystemPreset: {
        invoiceSystemType: 1,
        isActive: false,
        primaveraGetArticlesURL: '',
        primaveraPostInvoiceURL: '',
        primaveraGetInvoiceCreditNoteURL: '',
        primaveraGetInvoiceDocumentURL: ''
    },
    selectedInvoice: null,
    invoicingIntegrationOptions:[
        {
            id: 0,
            name: 'None'
        },
        {
            id: 1,
            name: 'Primavera'
        }
    ],
    invoicingOptions:[
        {
            id: 0,
            label:"Automatically"
        },
        {
            id: 1,
            label:"Manually"
        }
    ],
    invoiceTargetTypes:[
        {
            id: 0,
            label: 'End customer'
        },
        {
            id: 1,
            label: 'Agent'
        },
    ],
    invoiceTypes: [
        {
            id: 0,
            label: 'Invoice'
        },
        {
            id: 1,
            label: 'Credit note'
        },
        {
            id: 10,
            label: 'Invoice/Receipt'
        }
    ],
    selectedReservationInvoiceResume: {},
    documentTypes: [],
    paymentTypes: [],
    chargeBackReasons: [],
    isResquestingDocumentTypes: false,
    isResquestingPaymentTypes: false,
    isResquestingChargeBackReason: false,
    selectedDocumentType: null,
    isResquestingPrimaveraSettings: false
};

const getters = {
    getSelectedInvoice: (state) => state.selectedInvoice,
    getDefaultInvoiceSystemPreset: (state) => state.defaultInvoiceSystemPreset,
    getInvoicingIntegrationOptions: (state) => state.invoicingIntegrationOptions,
    getInvoicingOptions: (state) => state.invoicingOptions,
    getInvoiceTargetTypes: (state) => state.invoiceTargetTypes,
    getInvoiceTypes: (state) => state.invoiceTypes,
    getIsCancellingInvoice: (state) => state.isCancelingInvoice,
    getIsPrintingInvoice: (state) => state.isPrintingInvoice,
    getIsCreatingInvoice: (state) => state.isCreatingInvoice,
    getIsDownloadingInvoiceResume: (state) => state.isDownloadingInvoiceResume,
    getIsDownloadingInvoiceResumeBulk: (state) => state.isDownloadingInvoiceResumeBulk,
    getValueToAskMoreBillingInfo: (state) => state.valueToAskMoreBillingInfo,
    getDocumentTypes: (state) => state.documentTypes,
    getPaymentTypes: (state) => state.paymentTypes,
    getChargeBackReason: (state) => state.chargeBackReasons,
    getIsDocumentTypesLoading: (state) => state.isResquestingDocumentTypes,
    getSelectedDocumentType: (state) => state.selectedDocumentType,
    getIsPrimaveraSettingsLoading: (state) => state.isResquestingPrimaveraSettings,
    getIsPaymentTypesLoading: (state) => state.isResquestingPaymentTypes,
    getIsChargeBackReasonsLoading: (state) => state.isResquestingChargeBackReason,
    getIsSendingInvoiceToMailLoading: (state) => state.isSendingInvoiceToMail,
};

const actions = {
    sendInvoiceToMail: ({state, commit, rootState}, payload) => {
        Vue.toasted.info(`Sending to ${payload.email}`, {duration: 2000});
        state.isSendingInvoiceToMail = true;
        
        return axios.get(`/api/invoice/Email?supplierId=${rootState.user.account.supplierId}&bookingInvoiceId=${payload.invoiceId}`)
        .then(response => {
            state.isSendingInvoiceToMail = false;

            if (response.status === 200) Vue.toasted.success('Sent', {duration: 2000});
        }).catch(err => {
            state.isSendingInvoiceToMail = false;
            
            Vue.toasted.error('Something went wrong', {duration: 2000});
        })
    },

    requestChargeBackReason: ({state, commit}) => {
        state.isResquestingChargeBackReason = true;
        
        return axios.get('/api/erp/chargebackreasons').then(response => {
            state.isResquestingChargeBackReason = false;

            if (response.status === 200) {
                commit('SET_CHARGE_BACK_REASONS', response.data);

                return response.data;
            }
        }).catch(err => {
            state.isResquestingChargeBackReason = false;
            
            return err;
        })
    },

    requestPaymentTypes: ({state, commit}) => {
        state.isResquestingPaymentTypes = true;
        
        return axios.get('/api/erp/paymentTypes').then(response => {
            state.isResquestingPaymentTypes = false;

            if (response.status === 200) {
                commit('SET_PAYMENT_TYPES', response.data);

                return response.data;
            }
        }).catch(err => {
            state.isResquestingPaymentTypes = false;
            
            return err;
        })
    },

    requestPrimaveraSettings: ({state, commit}) => {
        state.isResquestingPrimaveraSettings = true;
        
        return axios.get('/api/erp/primaveraSettings').then(response => {
            state.isResquestingPrimaveraSettings = false;

            if (response.status === 200) {
                return response.data;
            }
        }).catch(err => {
            state.isResquestingPrimaveraSettings = false;
            
            return err;
        })
    },

    requestDocumentTypes: ({state, commit}) => {
        state.isResquestingDocumentTypes = true
        
        return axios.get('/api/erp/documentTypes').then(response => {
            state.isResquestingDocumentTypes = false

            if (response.status === 200) {
                commit('SET_DOCUMENT_TYPES', response.data);
                
                return response.data;
            }
        }).catch(err => {
            state.isResquestingDocumentTypes = false
            
            return err;
        })
    },

    emitInvoice: ({state, commit, rootState}, payload) => {
        state.isCreatingInvoice = true;

        return axios.post('/api/invoice/CreateInvoice', {
            supplierId: rootState.user.account.supplierId,
            bookingId: payload.reservationId,
            invoiceTargetType: payload.invoiceTargetType,
            documentType: payload.documentType,
            paymentType: payload.paymentType,
            client: payload.client
        }).then(response => {
            state.isCreatingInvoice = false;
            
            return response;
        }).catch(err => {
            state.isCreatingInvoice = false;
            
            return response;
        })
    },

    emitInvoiceBulk: ({state, rootState}, payload) => {
        state.isCreatingInvoice = true

        // Set the correct "invoiceTargetType"
        let targetTypeId;
        
        if (payload.invoiceTo == 'customer') {
            targetTypeId = 0
        } else {
            if (payload.selectedAgent && payload.selectedAgent.isOTA == true) {
                targetTypeId = 2
            } else {
                targetTypeId = 1
            }
        }

        let dataToSend = {
            supplierId: rootState.user.account.supplierId,
            bookingSearchDepartureIn: rootState.reservations.reservationListType == 1? removeSdot(rootState.reservations.reservationListFilters) : null,
            bookingSearchSalesIn: rootState.reservations.reservationListType == 3? removeSdot(rootState.reservations.reservationListFilters) : null,
            bookingSearchTransfersIn: rootState.reservations.reservationListType == 2? removeSdot(rootState.reservations.reservationListFilters) : null,
            isToApplyAll: rootState.reservations.reservationListAllSelected,
            bookingList: rootState.reservations.bulkSelectedIds,
            isToManageInvoice: true,
            invoiceToForm: payload.invoiceToForm,
            invoiceTargetType: targetTypeId,
            documentType: payload.documentType
        }

        return axios.post('/api/invoice/createBulkInvoices', dataToSend).then(response => {
            state.isCreatingInvoice = false
            return response
        }).catch(err => {
            state.isCreatingInvoice = false
            return err
        })
    },

    cancelInvoice: ({state, rootState}, payload) => {
        Vue.toasted.info('Invoice cancelation is being processed, may take a moment.', {duration: 2000});
        state.isCancelingInvoice = true
        
        return axios.get('/api/Invoice/CancelInvoice',{
                params: {
                    supplierId: rootState.user.account.supplierId,
                    bookingId: payload.booking.id,
                    bookingInvoiceId: payload.invoice.id,
                    chargebackReason: payload.chargebackReason
                }
        }).then(response => {
            state.isCancelingInvoice = false;
            
            return response;
        }).catch(err => {
            state.isCancelingInvoice = false;
            
            return err.response;
        })
    },

    printInvoice: ({ state, commit, rootState }, payload) => {
        Vue.toasted.info('Your invoice is being prepared for download. Please allow a moment for processing.');
        state.isPrintingInvoice = true
        return axios.get('/api/Invoice/GetSupplierInvoiceDocument', {
            params: {
                supplierId: rootState.user.account.supplierId,
                bookingInvoiceId: payload
            },
            responseType: 'arraybuffer'
        }).then(response => {
            state.isPrintingInvoice = false
            return response

        }).catch(err => {
            state.isPrintingInvoice = false
            return err

        })
    },

    downloadReservationInvoiceResume: ({state, commit, rootState}, payload) => {
        state.isDownloadingInvoiceResume = true;
        return axios.get('/api/invoice/GetSupplierInvoiceResume', {
            params: {
                supplierId: rootState.user.account.supplierId,
                bookingId: payload.reservationId,
                documentType: payload.docType
            }
        }).then(response => {
            state.isDownloadingInvoiceResume = false;

            if(response.status == 200){
                commit('SET_RESERVATION_INVOICE_RESUME', response.data);
            }

            return response;
        }).catch(err => {
            state.isDownloadingInvoiceResume = false;

            throw err;
        })
    },

    downloadReservationInvoiceResumeBulk: ({state, commit, rootState}, payload) => {
        state.isDownloadingInvoiceResumeBulk = true

        let dataToSend = {
            supplierId: rootState.user.account.supplierId,
            bookingSearchDepartureIn: rootState.reservations.reservationListType == 1? removeSdot(rootState.reservations.reservationListFilters) : null,
            bookingSearchSalesIn: rootState.reservations.reservationListType == 3? removeSdot(rootState.reservations.reservationListFilters) : null,
            bookingSearchTransfersIn: rootState.reservations.reservationListType == 2? removeSdot(rootState.reservations.reservationListFilters) : null,
            isToApplyAll: rootState.reservations.reservationListAllSelected,
            bookingList: rootState.reservations.bulkSelectedIds,
            isToManageInvoice: true,
            invoiceToForm: payload.invoiceToForm,
            invoiceTargetType: payload.invoiceTo == 'agent'? 1 : 0,
        }

        return axios.post('/api/invoice/executeBulkInvoicesCalculations', dataToSend).then(response => {
            state.isDownloadingInvoiceResumeBulk = false

            if(response.status == 200){
                commit('SET_RESERVATION_INVOICE_RESUME', response.data)
            }

            return response
        }).then(err => {
            state.isDownloadingInvoiceResumeBulk = false
            return err
        })
    },

    getBookingsFromInvoice: ({state, rootState}, payload) => {
        return axios.get('/api/Invoice/GetSupplierBookingsByInvoice', {
            params: {
                supplierId: rootState.user.account.supplierId,
                bookingInvoiceId: payload.bookingInvoiceId
            }
        }).then(response => {
            if(response.status == 200){
                return response.data
            }
            return response
        }).catch(err => {
            return err
        })
    },

    setSelectedDocumentType: ({commit}, payload) => {
        commit('SET_SELECTED_DOCUMENT_TYPE', payload);
    },

    setSelectedInvoice: ({commit}, payload) => {
        commit('SET_SELECTED_INVOICE', payload);
    },
};

const mutations = {
    SET_PAYMENT_TYPES: (state, payload) => {
        state.paymentTypes = payload;
    },

    SET_DOCUMENT_TYPES: (state, payload) => {
        state.documentTypes = payload;
    },

    SET_CHARGE_BACK_REASONS: (state, payload) => {
        state.chargeBackReasons = payload;
    },

    SET_SELECTED_DOCUMENT_TYPE: (state, payload) => {
        state.selectedDocumentType = payload;
    },

    SET_SELECTED_INVOICE: (state, payload) => {
        state.selectedInvoice = payload;
    },

    SET_RESERVATION_INVOICE_RESUME: (state, payload) => {
        state.selectedReservationInvoiceResume = payload;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js